<div class="card-list-container">

  <div class="card" [class.full-width]="fullWidth"  *ngFor="let card of cards;">
    <app-card [inColumn]="false" [fixedHeight]="fixedHeight" (clicked)="navigate(card)" [card]="card"  [expanded]="true"></app-card>
  </div>
</div>